import { BASKET_TAB_VALUE } from '@/enums';

/**
 * @param {Array} arrCurrent
 * @param {Array} arrNew
 * @param {('basket' | 'wishList')} type
 * @return {(*&{isDeleted: boolean, isMoved: boolean})[]|*[]|[]}
 */
export const updateArr = (arrCurrent = [], arrNew = [], type = BASKET_TAB_VALUE) => {
  const isBasket = type === BASKET_TAB_VALUE;
  const isArrNewHasGift = !!arrNew.filter(item => item.isGift).length;
  const isOnlyGiftInCart = arrNew.length === 1 && isArrNewHasGift;
  const newArrProducts = isOnlyGiftInCart ? [] : arrNew;
  let arrCurrentModified = arrCurrent;

  if (isArrNewHasGift) {
    arrCurrentModified = arrCurrent.filter(item => !item.isGift);
  }

  // переносим подарок в начало
  const moveGift = (list) => {
    let newList = list;

    const giftIndex = newList.findIndex(item => item.isGift);
    if (giftIndex !== -1) {
      const giftItem = newList[giftIndex];
      newList.splice(giftIndex, 1);
      newList = [giftItem, ...list];
    }

    return newList;
  };

  // если нет модифицированных элементов то возвращаем обновленный список
  if (!arrCurrentModified.length) {
    const list = newArrProducts.map(item => ({
      ...item,
      isDeleted: false,
      isMoved: false,
      isLoading: false,
      isLoadingAddToBasket: false,
    }));

    return moveGift(list);
  }

  let tempArr = [];
  const tempArrNew = newArrProducts.map(item => item);

  const getProductId = item => (isBasket ? item.product.id : item.id);

  const getProductQuantity = item => (isBasket ? item.product.quantity : item.quantity);

  arrCurrentModified.forEach((innerItem) => {
    const indexItem = tempArrNew.findIndex(item => getProductId(item) === getProductId(innerItem));

    if (indexItem !== -1) {
      tempArr.push({
        ...tempArrNew[indexItem],
        isDeleted: false,
        isMoved: false,
        isLoading: false,
        isLoadingAddToBasket: false,
      });
      tempArrNew.splice(indexItem, 1);
    } else if (getProductQuantity(innerItem) >= 1 && !innerItem.isGift) {
      tempArr.push({
        ...innerItem,
        isDeleted: true,
      });
    }
  });

  if (tempArrNew.length) {
    tempArr = [...tempArr, ...tempArrNew];
  }

  return moveGift(tempArr);
};
